import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import {AppConfig} from './app.config';
import {storageFactory} from './app-storage';

@Injectable()
export class AppLoadService {
  appConfig: AppConfig;

  constructor(private httpClient: HttpClient) {
    this.appConfig = new AppConfig();
  }

  getToken(): Promise<any> {
    const promise = this.httpClient.post(this.appConfig.url + 'Auth/login', this.appConfig.tokenBody)
      .toPromise()
      .then(res => {
        if (localStorage == null) {
          const tokenElement = document.createElement('p');
          tokenElement.setAttribute('id', 'toktok');
          tokenElement.setAttribute('style', 'display:none;');
          const node = document.createTextNode(res['auth_token']);
          tokenElement.appendChild(node);
          const body = document.getElementsByTagName('body');
          body.item(0).appendChild(tokenElement);
        } else {
          storageFactory(localStorage).setItem('token', res['auth_token']);
        }
        return res;
      });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-load.service.ts